import React, { Component } from 'react';
import PropUpPage from 'Components/PopUpPage';
import { connect } from 'react-redux';
import { actions } from 'core/redux/features/booking';
import { BOOKING_STEP1 } from 'core/redux/features/booking/constants';
import { selectStepData } from 'core/redux/features/shared/reducers';
import { selectTranslator } from 'core/redux/features/languages/trans';
import { AppState } from 'core/redux/reducers';
import Menus from '../../Products/Page/Components/Menus';

interface IProps {
  onHide: () => void;
  hide: boolean;
}

class PopUpMenusComp extends Component<IProps, any> {
  render() {
    return (
      <PropUpPage
        hide={this.props.hide}
        onHide={this.props.onHide}
        isModal={true}
      >
        <Menus />
      </PropUpPage>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    trans: selectTranslator(state),
    step: selectStepData(state, 'booking', BOOKING_STEP1),
  };
};

const mapDispatchToProps = {
  onUpdateMenu: actions.selectProductMenu,
};

const PopUpMenus = connect(mapStateToProps, mapDispatchToProps)(PopUpMenusComp);

export default PopUpMenus;
